import client from "../Client/HttpClient";
import { ITuitionDiscountsModel } from "@/interfaces/modules";
const ApiPath = "TuitionDiscounts";

export default {
    GetDiscounts: (): Promise<ITuitionDiscountsModel[]> => client.get(`${ApiPath}`),
    GetDiscountById: (data: ITuitionDiscountsModel): Promise<ITuitionDiscountsModel> => client.get(`${ApiPath}/${data.Id}`),
    PostDiscount: (data: ITuitionDiscountsModel): Promise<ITuitionDiscountsModel> => client.post(`${ApiPath}`, data),
};
